import { render, staticRenderFns } from "./LinkUserEmployeesModal.vue?vue&type=template&id=2a33ecc2"
import script from "./LinkUserEmployeesModal.vue?vue&type=script&lang=js"
export * from "./LinkUserEmployeesModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports